export const isDesktop = () => {
    if (!window.data?.crm?.sesion?.infonavegador) {
        return window.matchMedia('(min-width: 1024px)').matches;
    }

    return window.data.crm.sesion.infonavegador.dispositivo === 'desktop';
}

export const isMobile = () => {
    if (!window.data?.crm?.sesion?.infonavegador) {
        return window.matchMedia('(max-width: 480px)').matches;
    }

    return window.data.crm.sesion.infonavegador.dispositivo === 'smartphone';
}

export const esDispositivoApple = () => {
    if (!window.data?.crm?.sesion?.infonavegador) {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }

    return window.data.crm.sesion.infonavegador.marca === 'Apple';
}

export const isIpad = () => {
    if (!window.data?.crm?.sesion?.infonavegador) {
        return /iPad/.test(navigator.userAgent) && !window.MSStream;
    }

    return window.data.crm.sesion.infonavegador.modelo === 'iPad';
}

export const isSafari = () => {
    if (!window.data?.crm?.sesion?.infonavegador) {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }

    return window.data.crm.sesion.infonavegador.navegador.name === 'Safari';
}

export const getLang = () => {
    return window.data?.crm?.sesion?.lang?.replace('_', '-') || 'es-ES';
}

export const svprintf = (str, values = []) => {
    return str
        .split('%s')
        .map((x, idx, src) => (
            idx === src.length - 1 ? x : x + (typeof values[idx] !== 'undefined' ? values[idx] : '%s'))
        )
        .join('');
}

export const _ = (str, values) => typeof window._ === 'function' ? window._(str, values) : svprintf(str, values);

export const throttle = (f, ms) => {
    let isCooldown = false;

    return function() {
        if (isCooldown) return;

        f.apply(this, arguments);

        isCooldown = true;

        setTimeout(() => isCooldown = false, ms);
    };
}

export const sinDiacriticos = str => {
    let de = 'ÁÃÀÄÂÉËÈÊÍÏÌÎÓÖÒÔÚÜÙÛÑÇáãàäâéëèêíïìîóöòôúüùûñç';
    let a = 'AAAAAEEEEIIIIOOOOUUUUNCaaaaaeeeeiiiioooouuuunc';
    let re = new RegExp('['+de+']' , 'ug');

    return str.replace(re, match => a.charAt(de.indexOf(match)));
}

export const sanearTexto = str => {
    return sinDiacriticos(str.toLowerCase().trim());
}

export const buscarPorId = (array, id) => {
    for (let elem of array) {
        if (elem.id === id) return elem;

        if (elem.hijos) {
            const encontrado = buscarPorId(elem.hijos, id);

            if (encontrado) return encontrado;
        }
    }

    return null;
}

export const crearArbolDesdeLista = lista => {
    const convertirDato = dato => ({
        ...dato,
        idPadre: typeof dato.idPadre !== 'undefined'
            ? dato.idPadre
            : typeof dato.idpadre !== 'undefined'
                ? dato.idpadre
                : null,
        hijos: []
    });

    const ordenAlfabetico = (a, b) => {
        if (!a.nombre || !b.nombre) {
            return 1;
        }

        return sanearTexto(a.nombre).localeCompare(sanearTexto(b.nombre));
    }

    const ordenCategoria = (a, b) => {
        if (b.seleccionable === a.seleccionable) {
            return ordenAlfabetico(a, b)
        }
        return a.seleccionable ? 1 : -1;
    }

    const agruparCategorias = lista => {
        const array = [...lista];

        array.sort(ordenCategoria);

        for (let elem of array) {
            if (Array.isArray(elem.hijos) && elem.hijos.length > 0) {
                agruparCategorias(elem.hijos);
            }
        }

        return array;
    }

    // Se ordena la lista alfabéticamente
    const listaOrdenada = [...lista].sort(ordenAlfabetico);

    // Convertimos el formato de base de datos
    const listaConvertida = listaOrdenada.map(x => convertirDato(x));

    // Iniciamos la lista solo con los padres de primer nivel
    const listaCategorizada = listaConvertida.filter(elem => elem.idPadre === null);

    // Recorremos el resto de la lista y vamos insertando los hijos
    let listaHijos = listaConvertida.filter(elem => elem.idPadre !== null);

    do {
        listaHijos.forEach(hijo => {
            const padre = buscarPorId(listaCategorizada, hijo.idPadre);

            if (padre) {
                padre.hijos.push(hijo);
                listaHijos = listaHijos.filter(x => x.id !== hijo.id);
            }
        });
    } while (listaHijos.length > 0);

    // Se ordena la lista de forma recursiva, primero categorías y en cada nivel
    const listaAgrupadaPorCategorias = agruparCategorias(listaCategorizada);

    return listaAgrupadaPorCategorias;
}

export const eliminarDuplicadosPorId = arr => {
    const vistos = new Set();

    return arr.filter(el => {
        const duplicado = vistos.has(el.id);
        vistos.add(el.id);
        return !duplicado;
    });
}

export const recuperarLista = (nombreLista, conCategorias = false, pintarNombrePadre = false) => {
    const tipo = nombreLista.startsWith('var-') ? 'variable' : 'data-lista';

    const lista = tipo === 'variable' ? nombreLista.replace('var-', '') : nombreLista;

    let listado = [];

    if (tipo === 'variable') {
        try {
            listado = new Function(`return ${lista}`)();
        } catch(err) {
            throw new Error(`La variable ${lista} no existe`);
        }
    } else {
        if (data.listas && data.listas[lista]) {
            listado = JSON.parse(JSON.stringify(data.listas[lista]));
        } else {
            if (!window.arrlistas[lista]) {
                throw new Error(`La lista ${lista} no existe en data.listas ni arrlistas`);
            }

            listado = window.arrlistas[lista]
                .reduce((acc, curr, idx, arr) => {
                    if (idx > 0 && idx % 2 !== 0 && arr[idx - 1] !== '') {
                        acc.push({
                            id: arr[idx - 1],
                            nombre: curr
                        });
                    }
                    return acc;
                }, [])
        }
    }

    if (pintarNombrePadre) {
        listado.forEach(elem => {
            const idPadre = elem.idPadre ?? elem.idpadre;

            if (idPadre) {
                const padre = listado.find(x => x.id.toString() === idPadre.toString());

                if (padre) {
                    elem.nombreConPadre = padre.nombre + ' → ' + (elem.nombreInput ?? elem.nombre);
                }
            }
        })
    }

    if (!conCategorias) {
        // Contemplar 'undefined' para listados viejos de arrlistas
        listado = eliminarDuplicadosPorId(listado).filter(
            x => typeof x.seleccionable === 'undefined' || x.seleccionable
        );
    }

    const parseId = id => (!isNaN(parseInt(id)) && parseInt(id) === parseFloat(id)) ? parseInt(id) : id;

    listado.forEach(elem => elem.id = parseId(elem.id));

    return listado;
}


export const strToElement = html => {
    const parent = document.createElement('div');
    parent.innerHTML = `<template>${html}</template>`;
    return parent.firstElementChild.content.firstElementChild
}

export const tieneOverflow = (elem, tipo = 'x') => {
    const tempElem = elem.cloneNode(true);

    tempElem.className = '';
    tempElem.id = '';

    for (let key in tempElem.dataset) {
        delete tempElem.dataset[key];
    }

    tempElem.style = `
        display: inline;
        width: auto;
        visibility: hidden;
        z-index: -1;
        position: fixed;
        top: 0;
        left: 0;
    `;

    document.body.append(tempElem);

    const result = tempElem.getBoundingClientRect()[tipo] > elem.getBoundingClientRect()[tipo];

    tempElem.remove();

    return result;
}

export const obtenerPosicionRelativa = (elementoRelativo, elementoReferencia) => {
    const MARGEN_Y = 40;
    const MARGEN_X = 10;

    const { left: refLeft, top: refTop, width: refWidth } = elementoReferencia.getBoundingClientRect();

    const elemHeight = elementoRelativo.offsetHeight;
    const elemWidth = elementoRelativo.getBoundingClientRect().width;

    const offsetDer = elemWidth - refWidth;

    const hayEspacioArriba = refTop >= elemHeight + MARGEN_Y;
    const hayEspacioDebajo = window.innerHeight - refTop - MARGEN_Y >= elemHeight;
    const hayEspacioIzquierda = refLeft >= elemWidth + MARGEN_X;
    const hayEspacioDerecha = refLeft + elemWidth + MARGEN_X <= window.innerWidth;

    const elemLeft = hayEspacioDerecha ? refLeft : refLeft - offsetDer;
    const elemTop = hayEspacioDebajo ? refTop + elementoReferencia.offsetHeight : refTop - elemHeight;

    return {
        top: elemTop,
        left: elemLeft,
        hayEspacioArriba,
        hayEspacioDebajo,
        hayEspacioIzquierda,
        hayEspacioDerecha
    }
}

export const getContenidoTemplate = template => {
    const div = document.createElement('div');
    div.append(template.content.cloneNode(true));
    const contenido = div.innerHTML.trim();
    div.remove();

    return contenido;
}

export const convertTZ = (date, tzString) => {
    return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString('en-US', { timeZone: tzString }));
}

export const asyncCachingDecorator = (func, msDelete = 0) => {
    const cache = new Map();

    return async function(x) {
        if (cache.has(x)) {
            return cache.get(x);
        }

        const result = await func(x);
        cache.set(x, result);

        if (msDelete > 0) {
            setTimeout(() => cache.delete(x), msDelete);
        }

        return result;
    };
}

export const setLocalStorage = (name, value) => {
    if (window.setLocalStorage) {
        return window.setLocalStorage(name, value);
    }

    localStorage.setItem(name, value);
}

export const getLocalStorage = name => {
    if (window.getLocalStorage) {
        return window.getLocalStorage(name);
    }

    return localStorage.getItem(name);
}

export const removeFromLocalStorage = name => {
    if (window.setLocalStorage) {
        return window.setLocalStorage(name, null);
    }

    return localStorage.removeItem(name);
}

export const crearClassName = arr => {
    return arr.filter(Boolean).join(' ');
}

export const binarioToPosiciones = binario => {
    if (!binario) return '';

    return [...bigInt(binario).toString(2)].reduce((acc, curr, idx, arr) => {
        if (curr === '1') {
            acc.push(Math.pow(2, arr.length - 1 - idx));
        }

        return acc;
    }, []).join(',');
}

export const posicionesToBinario = valor => {
    const posiciones = valor.toString();

    if (!posiciones) return '';

    const posicionesArr = posiciones.split(',').map(Number);
    let binario = 0;

    posicionesArr.forEach(posicion => {
        binario += Math.pow(2, Math.log2(posicion));
    });

    return binario;
}
